import React, { useEffect, useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import { MenuIcon, XIcon } from 'lucide-react';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const {
    scrollY
  } = useScroll();
  useEffect(() => {
    return scrollY.on('change', latest => {
      setIsScrolled(latest > 50);
    });
  }, [scrollY]);
  const navLinks = [{
    label: 'Home',
    href: '#home'
  }, {
    label: 'About',
    href: '#about'
  }, {
    label: 'Services & Rates',
    href: '#experiences'
  }, {
    label: 'Etiquette',
    href: '#etiquette'
  }, {
    label: 'FAQ',
    href: '#faq'
  }, {
    label: 'Testimonials',
    href: '#testimonials'
  }, {
    label: 'Contact',
    href: '#contact'
  }];
  return <motion.nav initial={{
    backgroundColor: 'rgba(10, 7, 8, 0)'
  }} animate={{
    backgroundColor: isScrolled ? 'rgba(10, 7, 8, 0.95)' : 'rgba(10, 7, 8, 0)',
    borderBottomColor: isScrolled ? 'rgba(201, 168, 118, 0.2)' : 'rgba(201, 168, 118, 0)'
  }} className="fixed top-0 left-0 right-0 z-50 border-b transition-all duration-300" data-id="element-254">
      <div className="max-w-7xl mx-auto px-6 lg:px-12" data-id="element-255">
        <div className="flex items-center justify-between h-44" data-id="element-256">
          {/* Logo */}
          <a href="#home" className="flex items-center" aria-label="Madam Yas — home" data-id="element-257">
            <img src="https://cdn.magicpatterns.com/uploads/3cysW5AXtjSc9R4hRWj3oj/001.png" alt="Madam Yas" className="h-40 w-40 object-contain" data-id="element-258" />
          </a>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8" data-id="element-259">
            {navLinks.map(link => <a key={link.href} href={link.href} className="text-silver text-xs uppercase tracking-widest hover:text-gold transition-colors duration-300" data-id="element-260">
                {link.label}
              </a>)}
          </div>

          {/* Desktop Right Side */}
          <div className="hidden lg:flex items-center space-x-5" data-id="element-261">
            <a href="tel:5625480191" className="text-silver-muted text-xs tracking-wider hover:text-gold transition-colors" data-id="element-262">
              562.548.0191
            </a>
            <a href="https://tiptopjar.com/Madamyas" target="_blank" rel="noopener noreferrer" style={{
            backgroundColor: '#B794D4',
            color: '#07050A',
            borderColor: '#B794D4'
          }} className="inline-flex items-center gap-2 rounded-full border-2 px-5 py-2.5 text-sm font-semibold uppercase tracking-[0.15em] hover:bg-[#ECE6F5] hover:border-[#ECE6F5] transition-all duration-300 shadow-[0_0_24px_rgba(183,148,212,0.45)] hover:shadow-[0_0_40px_rgba(183,148,212,0.7)] hover:-translate-y-0.5" data-id="element-263">
              Leave a Tip
              <span aria-hidden className="text-base leading-none" data-id="element-264">
                ❤
              </span>
            </a>
            <a href="#contact" className="px-5 py-2 border border-gold text-gold text-xs uppercase tracking-widest hover:bg-gold hover:text-ink transition-all duration-300" data-id="element-265">
              Request Consultation
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="lg:hidden text-gold" aria-label="Toggle menu" data-id="element-266">
            {mobileMenuOpen ? <XIcon size={24} data-id="element-267" /> : <MenuIcon size={24} data-id="element-268" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <motion.div initial={{
      opacity: 0,
      y: -20
    }} animate={{
      opacity: 1,
      y: 0
    }} className="lg:hidden bg-onyx border-t border-gold/20" data-id="element-269">
          <div className="px-6 py-6 space-y-4" data-id="element-270">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block text-silver text-sm uppercase tracking-widest hover:text-gold transition-colors" data-id="element-271">
                {link.label}
              </a>)}
            <div className="pt-4 border-t border-gold/20 space-y-3" data-id="element-272">
              <a href="tel:5625480191" className="block text-silver-muted text-sm tracking-wider" data-id="element-273">
                562.548.0191
              </a>
              <a href="https://tiptopjar.com/Madamyas" target="_blank" rel="noopener noreferrer" onClick={() => setMobileMenuOpen(false)} style={{
            backgroundColor: '#B794D4',
            color: '#07050A',
            borderColor: '#B794D4'
          }} className="flex items-center justify-center gap-2 w-full text-center px-5 py-3.5 rounded-full border-2 text-sm font-semibold uppercase tracking-widest shadow-[0_0_24px_rgba(183,148,212,0.45)] hover:shadow-[0_0_40px_rgba(183,148,212,0.7)] transition-all" data-id="element-274">
                Leave a Tip
                <span aria-hidden className="text-base leading-none" data-id="element-275">
                  ❤
                </span>
              </a>
              <a href="#contact" onClick={() => setMobileMenuOpen(false)} className="block w-full text-center px-5 py-3 border border-gold text-gold text-xs uppercase tracking-widest hover:bg-gold hover:text-ink transition-all" data-id="element-276">
                Request Consultation
              </a>
            </div>
          </div>
        </motion.div>}
    </motion.nav>;
}